import { useEffect, useState } from 'react';

import type { CSSProperties } from 'react';

// iOS Safari doesn't shrink the layout viewport when the keyboard opens, so a 100dvh container keeps
// its full height and the composer ends up behind the keyboard. It also scrolls the page up rather
// than resizing it, which is what offsetTop corrects for. visualViewport reports what's actually
// still visible; browsers without it fall back to dvh.
export function useVisualViewport(): CSSProperties {
  const [box, setBox] = useState<{ height: number, top: number } | null>(null);

  useEffect(() => {
    const viewport = window.visualViewport;
    if (!viewport) {
      return;
    }

    const measure = () => setBox({ height: viewport.height, top: viewport.offsetTop });

    measure();
    viewport.addEventListener('resize', measure);
    viewport.addEventListener('scroll', measure);

    return () => {
      viewport.removeEventListener('resize', measure);
      viewport.removeEventListener('scroll', measure);
    };
  }, []);

  return box ? { height: `${box.height}px`, top: `${box.top}px` } : { height: '100dvh', top: 0 };
}
